import log from 'salvo-lite/log'

class Collection {
    constructor (theme) {
        this._theme = theme
        this._prodContainer = document.querySelector('.boost-pfs-filter-wrapper-page')
        this._progress = document.querySelector('.collection__progress-bar')
        this._mobileDescription = document.querySelector('.collection__description-mobile')
        log.debug(this.constructor.name, 'Constructed', this)
    }
    onInit () {
        this._observer()
        if (window.innerWidth < 769) {
            this._mobileDescriptionCalc()
        }
    }
    _observer () {
        const config = { childList: true, subtree: true }
        const callback = (mutationsList, observer) => {
            for (let mutation of mutationsList) {
                this._doComponents(mutation)
                if (this._progress) {
                    this._progressCalc()
                }
            }
        }
        let observer = new MutationObserver(callback)
        observer.observe(this._prodContainer, config)
    }
    _doComponents (mutation) {
        if (mutation.target.classList.contains('boost-pfs-filter-products')) {
            let products = this._prodContainer.querySelectorAll('.product-item')
            for (let product of products) {
                this._theme.registerComponents(product)
            }
            const event = new CustomEvent('collectionUpdate')
            document.dispatchEvent(event)
        } else if (mutation.target.classList.contains('boost-pfs-filter-tree') || mutation.target.classList.contains('boost-pfs-filter-option-item-list boost-pfs-filter-option-item-list-multiple-list') || mutation.target.classList.contains('boost-pfs-filter-options-wrapper') || mutation.target.classList.contains('boost-pfs-filter-refine-by-wrapper-h')) {
            let filters = document.querySelectorAll('[data-filter]')
            for (let filter of filters) {
                this._theme.registerComponents(filter.parentNode)
            }
        }
    }
    _progressCalc () {
        if (document.querySelector('.boost-pfs-filter-load-more-total')) {
            // const prodsOnDisplay = document.querySelectorAll('.product-item').length
            let loadmoreText = document.querySelector('.boost-pfs-filter-load-more-total').textContent.toLowerCase()
            loadmoreText = loadmoreText.replace(/[a-z]+/g, '').replace(/\s+/g, ' ').trim()
            const viewing = loadmoreText.split(' ')[0]
            const total = loadmoreText.split(' ')[1]
            const width = (parseInt(viewing) / parseInt(total)) * 100
            this._progress.style.width = width + '%'
        }
    }
    _mobileDescriptionCalc () {
        const descriptionSize = this._mobileDescription.offsetHeight
        if (descriptionSize > 53) {
            this._mobileDescription.classList.add('DOM-slider-hidden')
            this._mobileDescription.nextElementSibling.classList.remove('visually-hidden')
        }
    }
}
export default Collection



// WEBPACK FOOTER //
// ./src/resources/scripts/pages/Collection.js